<panel *ngIf="!loading">
  <div header>{{"Danh sách tùy chỉnh" | lang}}</div>

  <table class="data" responsive>
    <tr>
      <th>{{"Tên" | lang}}</th>
      <th class="text-right">{{"Giá trị" | lang}}</th>
    </tr>
    <tr>
      <td>{{"Tỷ giá quy đổi CNY sang VND" | lang}}</td>
      <td>
        <number-input [value]="configs.cnyToVndConversion" (change)="configs.cnyToVndConversion = $event.target.value">
          <vnd-per-cny after></vnd-per-cny>
        </number-input>
      </td>
    </tr>
    <tr>
      <td>{{"Đơn vị làm tròn lên khi tính giá bán" | lang}}</td>
      <td>
        <number-input [value]="configs.vndRoundingFactor" (change)="configs.vndRoundingFactor = $event.target.value">
          <vnd after></vnd>
        </number-input>
      </td>
    </tr>
    <tr>
      <td>{{"Thời gian cho phép xem lại đơn hàng đã hoàn thành trong hoạt động" | lang}}</td>
      <td>
        <number-input [value]="configs.invoiceResolvableDays" (change)="configs.invoiceResolvableDays = $event.target.value">
          <unit after>ngày</unit>
        </number-input>
      </td>
    </tr>

    <tr>
      <td>{{"Thời gian cho phép nhập lại hàng, khấu trừ hàng lỗi" | lang}}</td>
      <td>
        <number-input [value]="configs.goodResolvableDays" (change)="configs.goodResolvableDays = $event.target.value">
          <unit after>ngày</unit>
        </number-input>
      </td>
    </tr>

    <tr>
      <td>{{"Độ dài tối đa của vải cắt mẫu" | lang}}</td>
      <td>
        <number-input [value]="configs.maxPrototypeLength" (change)="configs.maxPrototypeLength = $event.target.value">
          <m after></m>
        </number-input>
      </td>
    </tr>

    <tr>
      <td>{{"Lãi mặc định trên mét hàng bán ra" | lang}}</td>
      <td>
        <number-input [value]="configs.defaultProfitMargin * 100" (change)="configs.defaultProfitMargin = $event.target.value / 100">
          <unit after>%</unit>
        </number-input>
      </td>
    </tr>

    <tr>
      <td>{{"Phí vận chuyển mặc định trên mét hàng bán ra" | lang}}</td>
      <td>
        <number-input [value]="configs.defaultLogisticsMargin" [decimalPlaces]="1" (change)="configs.defaultLogisticsMargin = $event.target.value">
          <cny-per-m after></cny-per-m>
        </number-input>
      </td>
    </tr>

    <tr class="footer" *ngIf="!configs.synchronized">
      <td [colSpan]="2">
        <button class="text-white bg-primary w-100" (click)="configs.update()"><i class="fa fa-save"></i><span>{{"Cập nhật" | lang}}</span></button>
      </td>
    </tr>
  </table>
</panel>

<ngx-loading [show]="loading"></ngx-loading>
